const productTypes = {
  TICKET_WITH_SEAT: 'ST',
  SEAT_RESERVATION_ONLY: 'SO',
  TICKET_WITH_NO_SEAT: 'TO',
  BIKES: 'BK',
  PRAM: 'PR',
  GUIDE_DOG: 'DG',
  FOOD_AND_BEVERAGES: 'FB',
  FEE: 'FE',
  HOTEL: 'HO',
  VOUCHER: 'VC',
  INSURANCE: 'IN',
  EXTERNAL_TICKET: 'ET',
  LUGGAGE: 'LU',
  DISABILITY_SUPPORT: 'DS',
  PENALTY_FARE: 'PE',
  WIFI: 'WI',
  MERCHANDISE: 'MD',
  TAXI: 'TA',
  PARKING: 'PA',
  ENTERTAINMENT: 'EN',
  LOCAL_TRANSPORT: 'LT',
  CHAMPAIGN: 'ME'
};

export default productTypes;
